import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";

export default function Manifesto() {
  const { t } = useLang();
  const m = t.manifesto;
  return (
    <section id="manifesto" className="relative py-24 md:py-36 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-coral-brand mb-5">{m.overline}</p>
          <h2 className="font-display text-4xl md:text-6xl font-bold tracking-tighter text-white max-w-2xl leading-[0.95]">
            {m.title}
          </h2>
        </Reveal>

        <div className="mt-16 grid md:grid-cols-2 gap-x-16 gap-y-12">
          {m.chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="border-t border-white/10 pt-6 flex gap-6">
                <span className="font-mono text-cyan-brand text-sm tracking-widest pt-1">{c.n}</span>
                <div>
                  <h3 className="font-display text-2xl md:text-3xl font-bold text-white tracking-tight">{c.title}</h3>
                  <p className="mt-3 text-white/60 leading-relaxed max-w-md">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
